import { FC } from "react";
import { CandidateRow } from "./CandidateRow";
import { Candidate } from "./types";

interface Props {
  copy: Record<string, string | undefined>;
  candidates: Candidate[];
  isSubstitutes?: boolean;
  showElectedCandidatesOnly?: boolean;
}

export const CandidatesTable: FC<Props> = ({
  copy,
  candidates,
  isSubstitutes,
  showElectedCandidatesOnly,
}) => {
  if (!candidates.length) {
    return (
      <p className="candidate-list__empty">
        {showElectedCandidatesOnly
          ? copy.candidateListNoResultsPostElection
          : copy.candidateListNoResults}
      </p>
    );
  }

  return (
    <div className="candidate-list__table">
      {candidates.map((candidate, i) => {
        const candidatePosition = showElectedCandidatesOnly
          ? undefined
          : isSubstitutes
          ? i + 1
          : candidate.position;

        return candidate.pageUrl ? (
          <a className="candidate-list__table__row" href={candidate.pageUrl}>
            <CandidateRow
              candidate={candidate}
              position={candidatePosition}
              isLink
            />
          </a>
        ) : (
          <div className="candidate-list__table__row">
            <CandidateRow candidate={candidate} position={candidatePosition} />
          </div>
        );
      })}
    </div>
  );
};
